/*eslint-disable*/
import api from '../'

class HomeWorkApi {

    // GET: homework/:id
    static show(id) {
        return api.axios.get('/homework/' + id).then(response => response.data);
    }

    // POST: homework
    static create(homework) {
        return api.axios.post('/homework', homework).then(response => response.data);
    }

    //PUT: homework/:id
    static update(id, homework) {
        return api.axios.put('/homework/' + id, homework).then(response => response.data);
    }

    // GET: homework
    static list(params, cancelToken = null) {
        return api.axios.get('/homework', {params, cancelToken}).then(response => response.data);
    }

    static delete(id) {
        return api.axios.delete('/homework/' + id).then(response => response.data);
    }

     static uncompletedHomework(params) {
         return api.axios.get('/homework/uncompleted', {params}).then(response => response.data);
     }
}

export default HomeWorkApi;
